export interface SupportedLocale {
  code: string
  name: string
  isDefault: boolean
}

export enum SupportedLanguageKeys {
  EN_US = 'en-US',
  ES_ES = 'es-ES',
  EN = 'en',
  ES = 'es',
}
